export default __webpack_public_path__ + "img/sagoo/sagoo3_480.webp";